import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "menuSetting"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Space, Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDropdown = styled(Dropdown).withConfig({
  displayName: "dropdowncomponent__StyledDropdown",
  componentId: "sc-1jk04vq-0"
})(["display:inline-block;width:100%;height:100%;.ant-space{width:inherit;}.ant-space-item{width:inherit;}"]);
var StyledDropdownDefaultCustom = styled(Space).withConfig({
  displayName: "dropdowncomponent__StyledDropdownDefaultCustom",
  componentId: "sc-1jk04vq-1"
})(["min-width:200px;min-height:80px;.ant-dropdown-menu-item,.ant-dropdown-menu-submenu-title{line-height:24px;font-size:16px;}.ant-space-item{width:100%;}"]);
export var DropdownComponent = function DropdownComponent(_ref) {
  var children = _ref.children,
      menuSetting = _ref.menuSetting,
      props = _objectWithoutProperties(_ref, _excluded);

  var overlayStyle = {
    border: '1px solid lightgray',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 1px 6px -4px rgba(0, 0, 0, 0.12)'
  };

  var DropdownRender = function DropdownRender() {
    return /*#__PURE__*/_jsx(StyledDropdownDefaultCustom, {
      children: /*#__PURE__*/_jsx(Menu, {
        items: menuSetting
      })
    });
  };

  return /*#__PURE__*/_jsx(StyledDropdown, _objectSpread(_objectSpread({}, props), {}, {
    overlayStyle: overlayStyle,
    dropdownRender: props.dropdownRender ? props.dropdownRender : DropdownRender,
    children: /*#__PURE__*/_jsx("a", {
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      children: children
    })
  }));
};